import { render } from "./_Pdf.vue?vue&type=template&id=8c16ee7e&scoped=true"
import script from "./_Pdf.vue?vue&type=script&lang=ts"
export * from "./_Pdf.vue?vue&type=script&lang=ts"

import "./_Pdf.vue?vue&type=style&index=0&id=8c16ee7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8c16ee7e"

export default script